import React from 'react';
import classnames from 'classnames';
import Check from '@mui/icons-material/Check';
import CheckBox from '@mui/icons-material/CheckBox';

import { Checkbox } from 'uikit/inputs';

import styles from '../styles/filterOption.module.scss';

const FilterOption = ({
  isSelected,
  isSingleSelect,
  name,
  onChange,
  value,
}) => (
  <Checkbox
    checkedIcon={isSingleSelect ? <Check /> : <CheckBox />}
    className={classnames(styles.element, isSingleSelect && styles.isSingleSelect)}
    id={`filter-option-${value}`}
    label={name}
    labelPosition={isSingleSelect ? 'left' : 'right'}
    onChange={onChange}
    inputTestId={`filter-option-${value}`}
    value={isSelected}
  />
);

export default React.memo(FilterOption);
